import React, { useState } from 'react';
import { connect } from 'react-redux';

import MainModalWrapper from '../../ManageProgram/View/components/MainModalWrapper';
import ProgramUsers from '../../ManageProgram/View/User';
import Subprograms from '../../ManageProgram/View/Subprogram';

const PUBLIC_URL = `${process.env.PUBLIC_URL}`;
const GeneralIcon = `${PUBLIC_URL}/img/icon/general.svg`;
const AccountingIcon = `${PUBLIC_URL}/img/icon/accounting.svg`;
const EventsIcon = `${PUBLIC_URL}/img/icon/events.svg`;
const EngagementIcon = `${PUBLIC_URL}/img/icon/engagement.svg`;

const SECTION_ITEMS = [
  { id: 'settings', label: 'Settings' },
  { id: 'users', label: 'Managers' },
  { id: 'subprograms', label: 'Subprograms' },
];

const SETTINGS_ACTIONS = [
  {
    id: 'general',
    title: 'General',
    description: 'Update base program information and configuration.',
    icon: GeneralIcon,
  },
  {
    id: 'themesettings',
    title: 'Theme Settings',
    description: 'Manage template styling and branding.',
    icon: EventsIcon,
  },
//   {
//     id: 'engagement',
//     title: 'Engagement',
//     description: 'Enable engagement features.',
//     icon: EngagementIcon,
//   },
  {
    id: 'digitalmedia',
    title: 'Upload Content',
    description: 'Manage brochures, newsletters, videos, and other assets.',
    icon: AccountingIcon,
  },
];

const ProgramAdmin = ({ program, organization, template }) => {
  const [activeSection, setActiveSection] = useState('settings');
  const [modalName, setModalName] = useState(null);
  const [isOpen, setOpen] = useState(false);

  const toggle = (name = null) => {
    if (name) {
      setModalName(name);
    }

    setOpen((previous) => !previous);
  };

  const openModal = (name) => {
    setModalName(name);
    setOpen(true);
  };

  const accentColor = template?.theme_color || template?.button_bg_color || 'var(--app-themeColor)';
  const accentContrastColor = template?.button_color || '#ffffff';
  const buttonBgColor = template?.button_bg_color || 'var(--app-button-bg, var(--app-themeColor))';
  const buttonTextColor = template?.button_color || 'var(--app-button-color, #ffffff)';
  const parsedButtonRadius = Number.parseInt(template?.button_corner, 10);
  const buttonRadius = Number.isFinite(parsedButtonRadius)
    ? `${parsedButtonRadius}px`
    : 'var(--app-button-radius, 10px)';

  if (!program?.id) {
    return (
      <div className="manager-card manager-card--loading">
        <span>Loading program administration...</span>
      </div>
    );
  }

  return (
    <div
      className="manager-program-admin"
      style={{
        '--manager-program-accent': accentColor,
        '--manager-program-accent-contrast': accentContrastColor,
        '--manager-program-button-bg': buttonBgColor,
        '--manager-program-button-color': buttonTextColor,
        '--manager-program-button-radius': buttonRadius,
      }}
    >
      <section className="manager-card manager-program-admin__hero">
        <div className="manager-program-admin__hero-copy">
          <span className="manager-card__eyebrow">Program Administration</span>
          <div className="manager-program-admin__title-row">
            <h1 className="manager-program-admin__title">{program.name}</h1>
          </div>
        </div>
      </section>

      <section className="manager-card manager-program-admin__sections">
        <div className="manager-program-admin__section-tabs pb-3" role="tablist" aria-label="Program administration sections">
          {SECTION_ITEMS.map((item) => (
            <button
              type="button"
              key={item.id}
              className={`manager-program-admin__section-tab${activeSection === item.id ? ' is-active' : ''}`}
              onClick={() => setActiveSection(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {activeSection === 'settings' && (
          <div className="manager-program-admin__section-panel">
            <div className="manager-program-admin__panel-head">
              <div>
                <span className="manager-card__eyebrow">Settings</span>
                <h2 className="manager-card__title">Program Configuration</h2>
              </div>
              <p className="manager-program-admin__panel-description">
                Configure branding, assets, and core program settings.
              </p>
            </div>

            <div className="manager-program-admin__settings-grid">
              {SETTINGS_ACTIONS.map((item) => (
                <button
                  type="button"
                  key={item.id}
                  className="manager-program-admin__setting-card"
                  onClick={() => openModal(item.id)}
                >
                  <span className="manager-program-admin__setting-icon">
                    <img src={item.icon} alt={item.title} />
                  </span>
                  <span className="manager-program-admin__setting-copy">
                    <span className="manager-program-admin__setting-title">{item.title}</span>
                    <span className="manager-program-admin__setting-description">{item.description}</span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}

        {activeSection === 'subprograms' && (
          <div className="manager-program-admin__section-panel">
            <div className="manager-program-admin__panel-head">
              <div>
                <span className="manager-card__eyebrow">Subprograms</span>
                <h2 className="manager-card__title">Hierarchy Management</h2>
              </div>
              <p className="manager-program-admin__panel-description">
                Manage child programs and the current hierarchy structure.
              </p>
              <button
                type="button"
                className="btn btn-primary account__btn account__btn--small"
                onClick={() => openModal('addprogram')}
              >
                Add Subprogram
              </button>
            </div>
            <Subprograms embedded={true} />
          </div>
        )}

        {activeSection === 'users' && (
          <div className="manager-program-admin__section-panel">
            <div className="manager-program-admin__panel-head">
              <div>
                <span className="manager-card__eyebrow">Users</span>
                <h2 className="manager-card__title">Program User Management</h2>
              </div>
              <p className="manager-program-admin__panel-description">
                Manage assigned users, access, invitations, and status.
              </p>
            </div>
            <ProgramUsers embedded={true} />
          </div>
        )}
      </section>

      <MainModalWrapper
        organization={organization}
        name={modalName}
        isOpen={isOpen}
        setOpen={setOpen}
        toggle={toggle}
        programId={program.id}
      />
    </div>
  );
};

export default connect((state) => ({
  program: state.program,
  organization: state.organization,
  template: state.template,
}))(ProgramAdmin);
